import { useCallback } from 'react'

import { unlocalizePathname, useRouter } from 'i18n/navigation'

function useChangeLanguage() {
    const router = useRouter()

    const changeLanguage = useCallback(
        (currentLng: string, newLng: string) => {
            const pathname = unlocalizePathname(window.location.pathname, currentLng)
            router.replace(pathname, { locale: newLng })
        },
        [router],
    )

    return { changeLanguage }
}

export { useChangeLanguage }
